import React from 'react';
import { Link } from 'react-router-dom';

const PageTitle = (props) => {
    return (
        <div style={{ display: 'none' }}>
            <div className="page-header">
                <h1 className="page-title">{props.titles}</h1>
                <div>
                    <ol className="breadcrumb">
                        {props.items.map((value, index) => {
                            return <li key={index} className="breadcrumb-item">
                                <Link to="#">{value}</Link>
                            </li>
                        })}
                        <li className="breadcrumb-item active" aria-current="page">{props.active}</li>
                    </ol>
                </div>
            </div>
        </div>
    )
}

export default PageTitle